import { useState, useCallback } from 'react';
import { SearchState } from '../types';

export const useSearchState = () => {
  const [searchState, setSearchState] = useState<SearchState>({
    searchTerm: '',
    replaceTerm: '',
    caseSensitive: false,
    wholeWord: false,
  });

  const handleInputChange = useCallback(
    (field: keyof SearchState) => (e: React.ChangeEvent<HTMLInputElement>) => {
      setSearchState((prev) => ({ ...prev, [field]: e.target.value }));
    },
    [],
  );

  const handleCheckboxChange = useCallback(
    (field: keyof SearchState) => (checked: boolean) => {
      setSearchState((prev) => ({ ...prev, [field]: checked }));
    },
    [],
  );

  const resetSearchTerms = useCallback(() => {
    setSearchState((prev) => ({
      ...prev,
      searchTerm: '',
      replaceTerm: '',
    }));
  }, []);

  return {
    searchState,
    handleInputChange,
    handleCheckboxChange,
    resetSearchTerms,
  };
};
